import * as React from 'react';
import { observer } from 'mobx-react';
import { IConfiguratorUIDto, UICfgBrandColorDefault } from '@canvas-logic/clp-api-types';
import { Bootstrapper } from '@/ui-kit/domain/Bootstrapper';
import { RalPalette } from '@/elements/attributes/RalAttribute/RalPalette';

import { OptionsViewStateName } from '@/stores/OptionsConfiguratorUIStore';
import { ElementRenderer } from '@/elements/ElementRenderer';

import './cp.css';
import classNames from 'classnames';

interface IProps {
  bootstrapper: Bootstrapper;
  configuratorUI: IConfiguratorUIDto;
  configuration: Record<string, never>;
}

export const UiBuilder: React.FC<IProps> = observer(function UiBuilder(props) {
  React.useEffect(() => {
    const brandColor = props.configuratorUI.brandColor || UICfgBrandColorDefault;
    if (brandColor) {
      const root: HTMLElement | null = document.querySelector(':root');
      if (root) {
        root.style.setProperty('--color-brand-rgb', `${brandColor.r},${brandColor.g},${brandColor.b}`);
        root.style.setProperty('--color-brand', `rgb(${brandColor.r},${brandColor.g},${brandColor.b})`);
      }
    }
  }, [props.configuratorUI.brandColor]);

  React.useEffect(() => {
    const configuratorUI = props.configuratorUI;

    if (configuratorUI?.theme?.overrideBasic && configuratorUI?.theme?.basic) {
      const style = document.createElement('style');
      style.setAttribute('id', 'overrideBasicTheme');
      style.innerHTML = configuratorUI?.theme?.basic;
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [props.configuratorUI.theme]);

  const { bootstrapper } = props;
  const { optionsViewStore } = bootstrapper;

  switch (optionsViewStore.view.name) {
    case OptionsViewStateName.INITIAL: {
      return (
        <div className={classNames('cp-root')}>
          <ElementRenderer state={bootstrapper.rootElement} />
        </div>
      );
    }
    case OptionsViewStateName.SELECT_CUSTOM_COLOR: {
      const viewState = optionsViewStore.view.state;
      const title = viewState.viewElement.uiControl.customColorOptions?.title;

      return (
        <RalPalette
          title={title}
          onClickBack={optionsViewStore.setInitialView}
          colors={viewState.customColors}
          onSelectColor={viewState.setCustomColor}
          selectedColor={viewState.color?.value}
        />
      );
    }
    default:
      return null;
  }
});
